import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {baseDocumentFields} from "../BaseDocumentFields";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";
import {KompenzacijaDocument} from "./KompenzacijaDocument";
import {IzvodOtvorenihStavkiDocument} from "./IzvodOtvorenihStavkiDocument";

// obavezno: datum zavodjenja, delovodni broj, datum dokumenta, broj dokumenta, partner, sektor
// opciono: osnov kompenzacije, lista priloga

export const izvodOtvorenihStavkiDocumentFields: IntercateKeysMap<IzvodOtvorenihStavkiDocument, EntityField<IzvodOtvorenihStavkiDocument>> = {
	...baseDocumentFields,
	clientId: {
		name: "clientId", dataType: EntityFieldDataType._reference, label: "Partner",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Customers
		},
		validator: { required: true },
		sortable: true,
		autocomplete: true
	},
	onDate: {
		name: "onDate", dataType: EntityFieldDataType._date, label: "Na dan",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
	parentId: {
		name: "parentId", dataType: EntityFieldDataType._derived, label: "Parent",
		value: item => item.clientId,
		hide: formState => true
	}
}

const documentFieldsArray: Array<EntityField<IzvodOtvorenihStavkiDocument>> = [
	izvodOtvorenihStavkiDocumentFields.indexingNumber,
	izvodOtvorenihStavkiDocumentFields.indexingDate,
	izvodOtvorenihStavkiDocumentFields.documentNumber,
	izvodOtvorenihStavkiDocumentFields.documentDate,
	izvodOtvorenihStavkiDocumentFields.assignedTo,
	izvodOtvorenihStavkiDocumentFields.clientId,
	izvodOtvorenihStavkiDocumentFields.sectorId,
	izvodOtvorenihStavkiDocumentFields.onDate,
	izvodOtvorenihStavkiDocumentFields.tags,
	izvodOtvorenihStavkiDocumentFields.description,
	izvodOtvorenihStavkiDocumentFields.parentId
]

export const izvodOtvorenihStavkiDocumentFieldsDescriptor: EntityFieldsDescriptor<IzvodOtvorenihStavkiDocument> = {
	listFields: documentFieldsArray,
	createFormFields: documentFieldsArray,
	updateFormFields: documentFieldsArray
}
